import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_BEGIN,
  MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_SUCCESS,
  MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_FAILURE,
  MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_DISMISS_ERROR,
} from './constants';
import { API_REQUEST_URL } from '../../../common/apiConfig';

export function checkAccountIfExist(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "descend",
          sortedBy: "modifiedTimestamp",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getManageAccountsData`, conditions, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCheckAccountIfExistError() {
  return {
    type: MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_DISMISS_ERROR,
  };
}

export function useCheckAccountIfExist() {
  const dispatch = useDispatch();

  const { checkAccountIfExistPending, checkAccountIfExistError } = useSelector(
    state => ({
      checkAccountIfExistPending: state.manageSubs.checkAccountIfExistPending,
      checkAccountIfExistError: state.manageSubs.checkAccountIfExistError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(checkAccountIfExist(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCheckAccountIfExistError());
  }, [dispatch]);

  return {
    checkAccountIfExist: boundAction,
    checkAccountIfExistPending,
    checkAccountIfExistError,
    dismissCheckAccountIfExistError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        checkAccountIfExistPending: true,
        checkAccountIfExistError: null,
      };

    case MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_SUCCESS:
      // The request is success
      return {
        ...state,
        addedAccountData: action.data,
        checkAccountIfExistPending: false,
        checkAccountIfExistError: null,
      };

    case MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_FAILURE:
      // The request is failed
      return {
        ...state,
        checkAccountIfExistPending: false,
        checkAccountIfExistError: action.data.error,
      };

    case MANAGE_SUBS_CHECK_ACCOUNT_IF_EXIST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        checkAccountIfExistError: null,
      };

    default:
      return state;
  }
}
